import { Outlet, createBrowserRouter } from 'react-router-dom';

import ErrorPage from 'kerberus-components/src/Components/Error/ErrorPage';

import App from '../App';
import DeviceListView from '../Views/Device';
import DeviceView from '../Views/Device/View';
import PlacesView from '../Views/Places';
import RedirectPageQR from '../Views/RedirectPageQR';
import ScanView from '../Views/Scan';
import TagResultView from '../Views/Scan/TagResultView';
import ScreenRegister from '../Views/Screen/Register';
import DataWallet from '../Views/Settings';
import TestRenkiTag from '../Views/Tags/TestRenkiTag';
import RootRoute from './RootRoute';

export const router = createBrowserRouter(
    [
        {
            children: [
                {
                    children: [
                        {
                            element: <PlacesView />,
                            path: '',
                        },
                        {
                            children: [
                                {
                                    element: <DeviceListView />,
                                    path: '',
                                },
                                {
                                    element: <DeviceView />,
                                    path: ':groupId',
                                },
                            ],
                            element: <Outlet />,
                            path: 'device',
                        },
                        {
                            element: <RedirectPageQR />,
                            path: 'qr/*',
                        },
                        {
                            element: <TestRenkiTag />,
                            path: 'testRenkiTag',
                        },
                        {
                            element: <DataWallet />,
                            path: 'settings',
                        },
                        {
                            element: <ScreenRegister />,
                            path: 'screen/register',
                        },
                        {
                            element: <ScanView />,
                            path: 'scan',
                        },
                        {
                            element: <TagResultView />,
                            path: 'scan/result',
                        },
                    ],
                    element: <App />,
                },
            ],
            element: <RootRoute />,
            errorElement: <ErrorPage />,
            path: '/*',
        },
    ],
    {
        future: {
            v7_fetcherPersist: true, // Retains fetcher state during navigation
            v7_normalizeFormMethod: true, // Normalizes form methods (e.g., POST or GET)
            v7_partialHydration: true, // Supports partial hydration for server-side rendering
            v7_relativeSplatPath: true, // Enables relative paths in nested routes
            v7_skipActionErrorRevalidation: true, // Prevents revalidation when action errors occur
        },
    },
);
